export const PREVENT_CLOSE_TARGETS_CLASS_NAMES = [
    'locale-settings-link',
    'locale-settings-modal',
    'locale-settings-package',
];
